import { StepProgress } from "../../StepProgress";
import { Text, Title } from "../../../styles/Texts";
import { Button } from "../../Button";
import { T } from "../../../styles/Theme";
import { useContext, useEffect, useState } from "react";
import TabButton from "../../TabButton";
import { DataContext } from "../../../contexts/DataContext";
import { Alternative, Data } from "../../../interfaces/IQuestions";
import axios from "axios";
import { CheckButton } from "../../CheckButton";
import {
  ClockStyled,
  Content,
  HeaderStyled,
} from "../../../styles/Screens/AlternativesStyled";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ClockLoader } from "react-spinners";
import { ADVISER_IDENTIFIER, QUESTIONS_API_URL } from "../../../env";
// import { anAlternativeHasBeenSelected, pressContinue, pressPrevious, questionLoaded } from "../../../utils/googleAnalytics";
import { ActivitiesToDoAlternativeSelectedGTM, ActivitiesToDoScreenUploadedGTM, ConnectedDivicesAlternativeSelectedGTM, ConnectedDivicesUploadedGTM, QuestionsButtonGTM, ServicesTypeScreenUploadedGTM, ServiceTypeAlternativeSelectedGTM } from "../../../utils/GoogleTagManager";
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from "../../../utils/common";
import { generateDataEvent } from "../../../utils/analytics";
import { uploadEventRequest } from "../../../utils/requests";

export const AlternativesScreen = () => {
  const [questionData, setQuestionData] = useState<Data | null>(null);
  const [currentStep, setCurrentStep] = useState<any>(1);

  const [idRedirection, setIdRedirection] = useState<null | number>(null);

  const [
    finalForm,
    setFinalForm,
    screenNumber,
    setScreenNumber,
    previousScreens,
    setPreviousScreens,
    ,
    ,
    questionId,
    setQuestionId,
    currentPage,
    setCurrentPage,
  ] = useContext(DataContext);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === questionId
    );
    // console.log("INDEX", index);

    if (index !== -1) {
      setIdRedirection(finalForm[index].alt_redirection);
    }

    if (questionId || questionId !== 0) {
      const url = `${questionId}/`;

      try {
        setLoading(true);
        axios
          .get(`${QUESTIONS_API_URL}/api/v1/questions/${url}`)
          .then((res) => {
            setQuestionData(res.data.data);
            setCurrentStep(res.data.data.stage.id);
            if (questionId === 1) ServicesTypeScreenUploadedGTM(window);
            if (questionId === 2 || questionId === 3 || questionId === 4) ConnectedDivicesUploadedGTM(window, getPlanSelected(finalForm));
            if (questionId === 5 || questionId === 6) ActivitiesToDoScreenUploadedGTM(window, getPlanSelected(finalForm), getConectedDevicesAlternatives(finalForm));
          })
          .then(() => {
            const index = previousScreens.findIndex(
              (el: any) => el.currentPage === currentPage
            );

            if (index === -1) {
              setPreviousScreens([
                ...previousScreens,
                { currentPage: currentPage, previousID: questionId },
              ]);
            } else {
              previousScreens[index].previousID = questionId;
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        console.log(error);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);

  const footerValidation = () => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === questionId
    );

    if (index === -1) {
      return true;
    }
  };

  const handleSelection = (alt: Alternative, question: Data) => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === question.id
    );

    if (index !== -1) {
      const indexToDelete: number[] = [];

      finalForm.forEach((el: any) => {
        const indexDelete = finalForm.findIndex((item: any) => {
          return item.id_question > finalForm[index].id_question;
        });

        if (indexDelete !== -1) {
          indexToDelete.push(indexDelete);
        }
      });

      indexToDelete.forEach((el: any) => {
        const arr = finalForm.splice(el, 1);
        setFinalForm(arr);
      });

      const arr = finalForm.splice(index, 1);
      setFinalForm(arr);
    }

    const indexAlternative = question.alternatives.findIndex(
      (el) => el.id === alt.id
    );
    let arrAnswer = Array(question.alternatives.length).fill(0);

    arrAnswer[indexAlternative] = 1;

    setFinalForm([
      ...finalForm,
      {
        id_question: question.id,
        answer: arrAnswer,
        title: question.title,
        id_alt: alt.id,
        alternative_text: alt.alternative_text,
        alt_redirection: alt.next_question_id.Int64,
      },
    ]);
    // console.log("FINAL FORM", finalForm);
      // anAlternativeHasBeenSelected(alt.alternative_text, question.id)
      if (questionId === 1) ServiceTypeAlternativeSelectedGTM(window, alt.alternative_text);
      if (questionId === 2 || questionId === 3 || questionId === 4) ConnectedDivicesAlternativeSelectedGTM(window, alt.alternative_text, getPlanSelected(finalForm));
      setIdRedirection(alt.next_question_id.Int64);

  };

  const handleMultipleSelection = (alt: Alternative, question: Data) => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === question.id
    );

    if (index !== -1) {
      const indexToDelete: number[] = [];

      finalForm.forEach((el: any) => {
        const indexDelete = finalForm.findIndex((item: any) => {
          return item.id_question > finalForm[index].id_question;
        });

        if (indexDelete !== -1) {
          indexToDelete.push(indexDelete);
        }
        // anAlternativeHasBeenSelected(alt.alternative_text, question.id)
      });

      indexToDelete.forEach((el: any) => {
        const arr = finalForm.splice(el, 1);
        setFinalForm(arr);
      });
    }

    const AltText = finalForm[index] ? finalForm[index].alternative_text : [];
    if (!finalForm[index]?.alternative_text.includes(alt.alternative_text)) {
      AltText.push(alt.alternative_text);
    } else {
      const indexItem = finalForm[index]?.alternative_text.indexOf(
        alt.alternative_text
      );
      if (indexItem > -1) {
        finalForm[index]?.alternative_text.splice(indexItem, 1);
      }
    }

    let arrAnswer = finalForm[index]
      ? finalForm[index].answer
      : Array(question.alternatives.length).fill(0);

    const AltSelected = finalForm[index] ? finalForm[index].id_alt : [];
    if (!finalForm[index]?.id_alt.includes(alt.id)) {
      AltSelected.push(alt.id);
    } else {
      const indexItem = finalForm[index]?.id_alt.indexOf(alt.id);
      if (indexItem > -1) {
        finalForm[index]?.id_alt.splice(indexItem, 1);
      }
    }

    const indexAlternative = question.alternatives.findIndex(
      (alternative) => alternative.id === alt.id
    );

    if (indexAlternative !== -1) {
      if (arrAnswer[indexAlternative] === 1) {
        arrAnswer[indexAlternative] = 0;
      } else {
        arrAnswer[indexAlternative] = 1;
      }
    }

    const alternativesArr: any = finalForm[index]
      ? finalForm[index].alternatives
      : [];
    const indexAlt = alternativesArr.findIndex(
      (item: any) => item.id_alternative === alt.id
    );
    if (indexAlt !== -1) {
      alternativesArr.splice(indexAlt, 1);
    } else {
      alternativesArr.push({
        id_alternative: alt.id,
        alternative_text: alt.alternative_text,
      });
    }

    if (index !== -1) {
      const arr = finalForm.splice(index, 1);
      setFinalForm(arr);
    }

    const finalObject = {
      id_question: question.id,
      answer: arrAnswer,
      title: question.title,
      id_alt: AltSelected,
      alternative_text: AltText,
      alt_redirection: alt.next_question_id.Int64,

      alternatives: alternativesArr,
    };

    setFinalForm([...finalForm, finalObject]);
    if (questionId === 5 || questionId === 6) {
      ActivitiesToDoAlternativeSelectedGTM(window, alt.alternative_text, getPlanSelected(finalForm), getConectedDevicesAlternatives(finalForm));
    }
    setIdRedirection(alt.next_question_id.Int64);
  };

  const handleValue = (question_id: number) => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === question_id
    );

    if (index !== -1) {
      return finalForm[index].id_alt;
    }
  };

  const handleMultipleValue = (question_id: number, alt: number) => {
    const index = finalForm.findIndex(
      (el: any) => el.id_question === question_id
    );

    if (index !== -1) {
      return finalForm[index].id_alt.includes(alt);
    }
  };

  // NAVIGATION
  const nextScreen = () => {
    const index = previousScreens.findIndex(
      (el: any) => el.currentPage === currentPage + 1
    );

    if (idRedirection !== 0 && !loading) {
      // pressContinue(questionId)
      // QuestionsButtonGTM(window, "siguiente", getPlanSelected(finalForm))
      setCurrentPage(currentPage + 1);
      if (index === -1) {
      }

      setQuestionId(idRedirection);
    } else {
      setScreenNumber(screenNumber + 1);
    }

    // ANALYTICS
    const code: string = `${ADVISER_IDENTIFIER}[n8723g@00df3.entel]`;
    const body: any = {
      data: generateDataEvent(questionData?.id || 0, questionData?.title || "")
    } 
    uploadEventRequest(JSON.stringify(body), code).then((res) => void(0));
  };

  const prevScreen = () => {
    if (screenNumber === 1 && !loading) {
      if (questionId === 1) {
        setScreenNumber(screenNumber - 1);
      } else {
        const index = previousScreens.findIndex(
          (el: any) => el.currentPage === currentPage - 1
        );

        setQuestionId(previousScreens[index].previousID);
        setCurrentPage(currentPage - 1);
      }
    }
    // pressPrevious(questionId)
  };

  const next = () => {
    QuestionsButtonGTM(window, "siguiente", getPlanSelected(finalForm), questionId, getConectedDevicesAlternatives(finalForm), getActivitiesToDo(finalForm));
    nextScreen();
  };

  const previous = () => {
    QuestionsButtonGTM(window, "volver", getPlanSelected(finalForm), questionId, getConectedDevicesAlternatives(finalForm), getActivitiesToDo(finalForm));
    prevScreen();
  };

  return (
    <>
      <HeaderStyled>
        <StepProgress step={1} currentStep={currentStep} />
      </HeaderStyled>
      <Content>
        <Title>{questionData ? questionData.title : <Skeleton />}</Title>
        {questionData?.description.String !== "" && (
          <Text>{questionData?.description.String}</Text>
        )}

        {questionData ? (
          <>
            {!questionData?.multiple_answers && (
              <div className="alternativesContainer">
                {questionData?.alternatives.map(
                  (alt: Alternative, i: number) => {
                    return (
                      <TabButton
                        tag={`${i}`}
                        key={`${alt.id} -- ${alt.alternative_text}`}
                        name={`${questionData?.title}`}
                        id={`${alt.id} -- ${alt.alternative_text}`}
                        text={alt.alternative_text}
                        onClick={() => handleSelection(alt, questionData)}
                        checked={handleValue(questionData?.id) === alt.id}
                      />
                    );
                  }
                )}
              </div>
            )}

            {questionData?.multiple_answers && (
              <div className="alternativesContainerMulti">
                {questionData?.alternatives.map(
                  (alt: Alternative, i: number) => {
                    return (
                      <CheckButton
                        tag={`${i}`}
                        key={`${alt.id} -- ${alt.alternative_text}`}
                        name={`${questionData?.title}`}
                        id={`${alt.id} -- ${alt.alternative_text}`}
                        text={alt.alternative_text}
                        onClick={() =>
                          handleMultipleSelection(alt, questionData)
                        }
                        checked={handleMultipleValue(questionData?.id, alt.id)}
                      />
                    );
                  }
                )}
              </div>
            )}
          </>
        ) : (
          <div className="alternativesContainer">
            <Title>
              <Skeleton />
            </Title>
            <Text>
              <Skeleton count={5} />
            </Text>
          </div>
        )}

        <div className="buttonContainer">
          <Button
            bg="transparent"
            c={T.blue}
            onClick={previous}
            disabled={loading}
          >
            Volver
          </Button>
          <Button
            bg={T.blue}
            c="white"
            onClick={next}
            disabled={footerValidation() || loading}
          >
            {loading ? (
              <ClockStyled>
                <ClockLoader size={30} color="white" />
              </ClockStyled>
            ) : (
              "Siguiente"
            )}
          </Button>
        </div>
      </Content>
    </>
  );
};
